export enum EntryTypeEnum {
    credit = 'credit',
    debit = 'debit',
}
